<template>
  <footer :class="['c-footer' , isExpanded ? 'is-expanded' : '']">
    <nav>
      <ul class="c-footer__navigation">
        <NavigationLink v-for="page in publicPages" :key="page.value" :page="page" />
        <li>
          <router-link to="/about" class="c-footer__link">About</router-link>
        </li>
        <li v-if="privatePage">
          <router-link :to="privatePage" class="c-footer__link">Private</router-link>
        </li>
      </ul>
    </nav>
    <button
      class="c-footer__expander"
      @click="isExpanded = !isExpanded"
    >
      <Chevron />
    </button>

    <div class="c-footer__contact-details">
      <div class="mb-xsmall">
        <span class="u-color-maroon u-bold">Bob Pendar-Hughes </span>
        | Director of Photography
      </div>
      <a href="mailto:bob@bobpendar-hughes.com" class="u-hover-maroon">
        bob@bobpendar-hughes.com
      </a>
      <a href="tel:+447973112807" class="u-hover-maroon">
        + 44 7973 112 807
      </a>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';
import Chevron from '@/assets/svg/Chevron.vue';
import NavigationLink from '@/components/NavigationLink.vue';

export default {
  data() {
    return {
      isExpanded: false,
    };
  },
  components: { Chevron, NavigationLink },
  computed: mapState({
    publicPages: state => state.publicSlugs,
    privatePage(state) {
      return state.privateSlug && `/private/${state.privateSlug}`;
    },
  }),
};
</script>
